var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPlusPlanIcon = function SvgPlusPlanIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.487 3.82673L7.00034 7.00006L1.51367 3.82673C1.62633 3.63174 1.78697 3.4688 1.98034 3.35339L6.33367 0.840059C6.74749 0.606699 7.25319 0.606699 7.667 0.840059L12.0203 3.35339C12.2137 3.4688 12.3744 3.63174 12.487 3.82673Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 6.99999V13.3333C6.78948 13.333 6.58207 13.2852 6.39301 13.1933L1.99967 10.6533C1.58786 10.4151 1.33391 9.97575 1.33301 9.49999V4.49999C1.33411 4.26381 1.39611 4.03189 1.51301 3.82666L6.99967 6.99999Z",
    fill: "#5CD6AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.49999V9.49999C12.6658 9.97575 12.4118 10.4151 12 10.6533L7.58667 13.2C7.40313 13.2866 7.20292 13.3321 7 13.3333V6.99999L12.4867 3.82666C12.6036 4.03189 12.6656 4.26381 12.6667 4.49999Z",
    fill: "#ADEBD6"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlusPlanIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/plusPlanIcon.778e189b.svg";
export { ForwardRef as ReactComponent };